export const ChatList = [
  {
    id: "4f5df5s",
    name: "Smith",
    status: true,
    conversation: [
      {
        m1: "Hello, How are you?",
        m2: "I also fine. And you?",
      },
      {
        m1: "What are you doing now",
        m2: "Nothing, Chatting with you",
      },
      {
        m1: "What are you doing now",
        m2: "Nothing, Chatting with you",
      },
    ],
  },
  {
    id: "fdf5s5f",
    name: "Rohit Sharma",
    status: true,
    conversation: [
      {
        m1: "Hello, How are you?",
        m2: "I also fine. And you?",
      },
      {
        m1: "What are you doing now",
        m2: "Nothing, Chatting with you",
      },
      {
        m1: "What are you doing now",
        m2: "Nothing, Chatting with you",
      },
    ],
  },
  {
    id: "7ks7fdifi",
    name: "Hardik pandya",
    status: false,
    conversation: [
      {
        m1: "Hello, How are you?",
        m2: "I also fine. And you?",
      },
      {
        m1: "What are you doing now",
        m2: "Nothing, Chatting with you",
      },
      {
        m1: "What are you doing now",
        m2: "Nothing, Chatting with you",
      },
    ],
  },
  {
    id: "74d8s5f5",
    name: "Moen Ali",
    status: true,
    conversation: [
      {
        m1: "Hello, How are you?",
        m2: "I also fine. And you?",
      },
      {
        m1: "What are you doing now",
        m2: "Nothing, Chatting with you",
      },
      {
        m1: "What are you doing now",
        m2: "Nothing, Chatting with you",
      },
    ],
  },
];
